<template>
  <div :class="$style.box">
    <!-- 顶部大banner -->
    <div
      :class="$style.banner"
      :style="{ backgroundImage: `url('${$cdnUrl}/dragonCity/top_bg.jpg?v=1')` }"
    >
      <!-- 下载游戏按钮 -->
      <div :class="$style.down" @click="jump"></div>
      <p v-if="userInfo.game_account === ''">
        绑定游戏账号立即参与活动： <span @click="handleBind">点我绑定</span>
      </p>
      <p v-else>
        已绑定账号：<span>{{ userInfo.game_account }}</span>
      </p>
      <!-- 标题一 -->
      <img :class="$style.title" :src="`${$cdnUrl}/dragonCity/title_01.png`" />
      <!-- 点击签到按钮 -->
      <img
        v-if="todaySignIn === 0"
        :class="$style.sign"
        :src="`${$cdnUrl}/dragonCity/button_sign.png`"
        @click="handleSign"
      />
      <img v-else :class="$style.sign" :src="`${$cdnUrl}/dragonCity/button_sign_done.png`" />
      <span>已累计签到{{ signDay }}天</span>
    </div>
    <!-- 签到礼包 -->
    <div :class="$style.signGift">
      <div
        :class="$style.content"
        :style="{ backgroundImage: `url('${$cdnUrl}/dragonCity/center_bg.png')` }"
      >
        <!-- 动效 -->
        <img :class="$style.light" :src="`${$cdnUrl}/dragonCity/light.gif`" />
        <div
          v-for="(item, index) in signList"
          :key="index"
          :style="{ backgroundImage: `url('${item.image}?v=2')` }"
          :class="`${item.sort <= signDay && getGiftIds.includes(item.id) ? $style.gary : null}`"
          @click="getGift(item.id, index, item.sort)"
        >
          <!-- 已领取 -->
          <div :class="$style.done" v-if="item.sort <= signDay && getGiftIds.includes(item.id)">
            <img :src="`${$cdnUrl}/dragonCity/word_done.png`" />
          </div>
          <!-- 未领取 -->
          <div :class="$style.get" v-if="item.sort <= signDay && !getGiftIds.includes(item.id)">
            <img :src="`${$cdnUrl}/dragonCity/word_get.png`" />
          </div>
          <!-- 不满足 -->
          <div :class="$style.not" v-if="item.sort > signDay">
            <img :src="`${$cdnUrl}/dragonCity/word_not.png`" />
          </div>
        </div>
      </div>
    </div>
    <!-- 幸运抽奖 -->
    <div :class="$style.lottery">
      <!-- 标题二 -->
      <img :class="$style.title" :src="`${$cdnUrl}/dragonCity/title_02.png`" />
      <p :class="$style.intro">累计签到5天、10天均可获得一次抽奖机会</p>
      <!-- 转盘部分 -->
      <div :class="$style.content">
        <img
          :src="`${$cdnUrl}/dragonCity/banner_01.png`"
          :class="runFlag ? $style.run : ''"
          :style="{ transform: `translateX(-50%) rotateZ(${deg}deg` }"
        />
        <img :src="`${$cdnUrl}/dragonCity/banner_02.png`" @click="doLottery" />
      </div>
      <p :class="$style.lotteryTime">
        剩余抽奖机会：<span>{{ lotteryTime }}次</span>
      </p>
      <p :class="$style.record" @click="openRecord">中奖记录</p>
      <img :class="$style.doneWord" :src="`${$cdnUrl}/dragonCity/done_word.png`" />
      <!-- 累签领取积分部分 -->
      <div :class="$style.signContent">
        <div :class="$style.signItem" v-for="(item, index) in ponitGiftList" :key="index">
          <span>累计签到{{ item.day }}天</span>
          <span>抽奖机会+{{ item.chance }}</span>
          <!-- 可领取 -->
          <img
            v-if="signDay >= item.day && !lotteryChance.includes(item.day)"
            :class="$style.btn"
            :src="`${$cdnUrl}/dragonCity/button_2_get.png`"
            @click="getChance(item.day)"
          />
          <!-- 不满足 -->
          <img
            v-if="signDay < item.day"
            :class="$style.btn"
            :src="`${$cdnUrl}/dragonCity/button_2_not.png`"
            @click="notFunc(2)"
          />
          <!-- 已领取 -->
          <img
            v-if="signDay >= item.day && lotteryChance.includes(item.day)"
            :class="$style.btn"
            :src="`${$cdnUrl}/dragonCity/button_2_done.png`"
          />
        </div>
      </div>
    </div>
    <!-- 游戏攻略 -->
    <div :class="$style.strategy">
      <!-- 标题三 -->
      <img :class="$style.title" :src="`${$cdnUrl}/dragonCity/title_03.png?v=1`" />
      <div :class="$style.content">
        <p v-for="(item, index) in strategyList" :key="index" @click="jumpT(item.id, item.c_id)">
          {{ item.name }}
        </p>
      </div>
      <p>更多内容，请前往<span @click="jumpQ(false)">傲世龙城圈子</span>查看</p>
      <img :class="$style.finger" :src="`${$cdnUrl}/dragonCity/icon_point.png`" />
    </div>
    <!-- 活动规则 -->
    <img
      :class="$style.ruleIcon"
      :src="`${$cdnUrl}/dragonCity/icon_rule.png`"
      @click="ruleShow = true"
    />
    <!-- 礼包弹窗 -->
    <DialogGift
      v-show="dialogGiftShow"
      :code="dialogGiftCode"
      :sort="dialogGiftSort"
      @closeGift="closeGift"
    ></DialogGift>
    <!-- 未登录弹窗 -->
    <div @touchmove.prevent :class="$style.noLogin" v-show="noLoginShow">
      <div
        :class="$style.content"
        :style="{ backgroundImage: `url('${$cdnUrl}/dragonCity/dialog_02.png')` }"
      >
        <img
          :class="$style.close"
          :src="`${$cdnUrl}/dragonCity/close_02.png`"
          @click="noLoginShow = false"
        />
        <p :class="$style.info">今日未登录游戏，签到失败 请先登录游戏</p>
        <div @click="noLoginShow = false">确认</div>
        <p :class="$style.noGame">没有游戏？<span @click="jump">点击下载</span></p>
      </div>
    </div>
    <!-- 活动规则弹窗 -->
    <div @touchmove.prevent :class="$style.actRule" v-show="ruleShow">
      <div :class="$style.content">
        <img :class="$style.title" :src="`${$cdnUrl}/dragonCity/title_04.png`" />
        <img
          :class="$style.close"
          :src="`${$cdnUrl}/dragonCity/close_03.png`"
          @click="ruleShow = false"
        />
        <div>
          <p>活动规则：</p>
          <p>
            1.活动期间，每日完成登录游戏即可在活动页面进行签到，累计签到满1/3/5/7/10/12天，均可领取对应奖励。
          </p>
          <p>
            2.累计签到满5天和满10天，可分别获取一次转盘抽奖机会，活动期间总计可获取2次抽奖机会，中奖率100％。
          </p>
          <p>
            3.领取到礼包的玩家点击弹窗的复制礼包码，前往【游戏内--右侧菜单--设置--兑换】处兑换。
          </p>
          <p>
            4.抽奖实物获奖玩家请及时填写收件信息，活动官方会在活动结束后14个工作日内寄出对应奖品。获奖玩家的收件信息填写截止于活动结束后7天。逾期未填的玩家信息将自动视为放弃。
          </p>
          <p :class="$style.palce"></p>
          <p>注意事项：</p>
          <p>1. 若在活动过程中遇到任何问题，请联系傲世龙城官方客服。</p>
          <p>2. 玩家每个累签礼包仅能领取一次，每个礼包仅能兑换一次。</p>
          <p>3. 抽奖福利中奖率概率为100%，玩家中奖后可在中奖记录中查看。</p>
          <p>4. 玩家领到礼包请及时兑换，避免逾期无法兑换，活动时间结束后将会无法查看礼包码。</p>
          <p>5. 本活动最终解释权归官方所有。</p>
        </div>
      </div>
    </div>
    <!-- 返回弹窗 -->
    <div @touchmove.prevent :class="$style.back" v-show="backShow">
      <div
        :class="$style.content"
        :style="{ backgroundImage: `url('${$cdnUrl}/dragonCity/image_leave.png')` }"
      >
        <img :class="$style.close" :src="`${$cdnUrl}/dragonCity/close_02.png`" @click="noJump" />
        <p v-if="todaySignIn !== 1" :class="$style.info">今日未签到，真的要错过礼包转盘福利吗？</p>
        <p v-else :class="$style.info">今日已签到完成，累计签到天数越高奖品越丰厚哦～</p>
        <p :class="$style.enter">
          在<span @click="jumpQ(true)">傲世龙城圈子</span>导航栏可找到该活动入口
        </p>
        <div>
          <div @click="back">知道了，确认离开</div>
          <div @click="noJump">继续领福利</div>
        </div>
      </div>
    </div>
    <!-- 中奖记录弹窗 -->
    <div :class="$style.recordDialog" v-show="recordShow">
      <div :class="$style.mask" @touchmove.prevent></div>
      <div
        :class="$style.content"
        :style="{ backgroundImage: `url('${$cdnUrl}/dragonCity/dialog_bg_1.png')` }"
      >
        <img :class="$style.title" :src="`${$cdnUrl}/dragonCity/word_record.png`" />
        <div :class="$style.header"><span>时间</span><span>奖品</span><span>礼包码</span></div>
        <div :class="$style.list">
          <div :class="$style.item" v-for="(item, index) in recordList" :key="index">
            <span>{{ item.created_at }}</span
            ><span>{{ item.name }}</span
            ><span>
              <span :class="`copyBtn ${$style.copy}`" @click="currentCode = item.reward_info"
                >复制</span
              ></span
            >
          </div>
        </div>
        <div :class="$style.close" @click="recordShow = false">关闭</div>
      </div>
    </div>
    <!-- 活动状态全局弹窗 -->
    <div v-if="state !== 1" :class="$style.outDialog" @touchmove.prevent>
      <div
        :class="$style.content"
        :style="{ backgroundImage: `url('${$cdnUrl}/dragonCity/dialog_02.png')` }"
      >
        <p v-if="state === 0">活动预计开始时间：11月24日10:00 <br />敬请关注哦~</p>
        <p v-else>活动已结束，进入【傲世龙城】官方论坛，领取更多福利~</p>
      </div>
    </div>
  </div>
</template>

<script>
import DialogGift from './components/dragonCity/DialogGift.vue';
import {
  signInLotteryActInfo,
  signInLotteryUserCInfo,
  signInLotterySignIn,
  signInLotteryGetGiftSecond,
  signInLotteryGetChance,
  signInLotteryDoLottery,
  signInLotteryGetLogSecond,
} from '@/api/activity';
import { mapState, mapMutations, mapActions } from 'vuex';
import Clipboard from 'clipboard';
import { reportData } from '@/api/report';

export default {
  components: {
    DialogGift,
  },
  data() {
    return {
      signList: [
        { image: `${this.$cdnUrl}/dragonCity/gift_01.png`, sort: 1 },
        { image: `${this.$cdnUrl}/dragonCity/gift_02.png`, sort: 3 },
        { image: `${this.$cdnUrl}/dragonCity/gift_03.png`, sort: 5 },
        { image: `${this.$cdnUrl}/dragonCity/gift_04.png`, sort: 7 },
        { image: `${this.$cdnUrl}/dragonCity/gift_05.png`, sort: 10 },
        { image: `${this.$cdnUrl}/dragonCity/gift_06.png`, sort: 12 },
      ], // 签到礼包状态列表
      ponitGiftList: [
        { chance: 1, day: '5' },
        { chance: 1, day: '10' },
      ], // 积分奖励列表
      strategyList: [
        { name: '龙城故事征集，给重要的人赢一份特别礼物~', id: 58764, c_id: 26 },
        { name: '答疑帖精华汇总：装备篇+玩法篇+人物篇', id: 52660, c_id: 26 },
        { name: '新八：小氪、中氪氪金消费指南，少花冤枉钱~', id: 61638, c_id: 26 },
        { name: '【新人攻略】元宝分配攻略+挂机指南', id: 33122, c_id: 26 },
        { name: '【答疑】时长两个月，随时解答各种游戏问题~', id: 35976, c_id: 26 },
      ], // 游戏攻略列表
      lotteries: [], // 抽奖转盘奖品ID数组 根据 welfare_id 匹配
      state: 1, // 当前活动状态 0 未开启 1 进行中 2 已结束
      nextFunc: null,
      signDay: 0, // 累计签到天数
      lotteryTime: 0, // 剩余抽奖次数
      todaySignIn: 0, // 今日是否已经签到 1 是
      lotteryChance: [], // 已领取的抽奖机会对应天数
      getGiftIds: [], // 已领取的礼包ID（包括签到和抽奖）
      dialogGiftShow: false, // 礼包弹窗是否展示
      dialogGiftSort: 0, // 礼包弹窗展示内容序号
      dialogGiftCode: '', // 礼包弹窗礼包码
      noLoginShow: false, // 未登录弹窗显示
      ruleShow: false, // 活动规则显示
      backShow: false, // 离开弹窗展示
      deg: 0, // 转盘旋转角度
      runFlag: false, // 是否做转盘动画
      recordShow: false, // 中奖记录弹窗显示
      recordList: [], // 中奖记录列表
      currentCode: '', // 当前复制的礼包码
      backF: false, // 是否为当前页面主动跳转
    };
  },
  created() {
    this.copyInit();
    this.getInfo();
    this.getUserInfo();
    reportData({ type: 14, data_type: 1 });
  },
  mounted() {
    if (window.history && window.history.pushState) {
      history.pushState(null, null, document.URL);
      window.addEventListener('popstate', this.goBack, false);
    }
  },
  destroyed() {
    window.removeEventListener('popstate', this.goBack, false);
  },
  computed: {
    ...mapState('account', {
      userInfo: (state) => state.userInfo, // 当前用户信息
    }),
  },
  // 此页面不能直接关闭，需弹出离开弹窗退出此页面
  beforeRouteLeave(to, from, next) {
    this.backShow = true;
    this.nextFunc = next;
  },
  methods: {
    ...mapMutations('app', {
      CHANGE_BIND_GAME: 'CHANGE_BIND_GAME',
    }),
    goBack() {
      //replace替换原路由，作用是避免回退死循环
      this.$router.push({ name: 'gameCircle.home', query: { circleId: '26' } });
    },
    // 获取活动信息
    async getInfo() {
      const r = await signInLotteryActInfo({});
      if (r.code !== 1) return;
      // 获取基本信息并且赋值
      const { info, gift, lotteries } = r.data;
      // 配置签到礼包 - 根据天数匹配
      this.signList.forEach((m) => {
        const obj = gift.filter((n) => {
          return n.sort === m.sort;
        })[0];
        obj && (m.id = obj.gift_id);
      });
      // 配置抽奖转盘 - 根据返回数组顺序 直接赋值
      this.lotteries = lotteries;
      this.state = info.state;
    },
    // 获取用户信息
    async getUserInfo() {
      const r = await signInLotteryUserCInfo();
      if (r.code !== 1) return;
      this.todaySignIn = r.data.today_sign_in;
      this.signDay = r.data.total_sign_in_day;
      this.lotteryTime = r.data.surplus_lottery_num;
      this.lotteryChance = r.data.get_lottery_chance;
      this.getGiftIds = r.data.get_gift;
    },
    // 点击绑定账号
    handleBind() {
      reportData({ type: 14, data_type: 2 });
      this.CHANGE_BIND_GAME(true);
    },
    // 点击不满足
    notFunc(type) {
      const str = type === 1 ? '不满足领取条件，请先签到' : '不满足领取条件';
      this.$toast.fail(str);
    },
    copyInit() {
      // 礼包领取成功弹窗中点击复制
      this.copy = new Clipboard('.copyBtn', {
        text: () => {
          return this.currentCode;
        },
      });
      this.copy.on('success', (e) => {
        this.$toast.success('复制成功');
      });
    },
    // 点击下载游戏链接
    jump() {
      this.backShow = true;
      this.backF = true;
    },
    // 点击签到
    async handleSign() {
      if (this.userInfo.game_account === '') {
        this.handleBind();
        return;
      }
      signInLotterySignIn().then(
        (r) => {
          if (r.code !== 1) return;
          this.$toast.success('签到成功');
          // 刷新用户信息
          this.getUserInfo();
        },
        (err) => {
          this.noLoginShow = true;
        },
      );
    },
    // 点击领取礼包
    async getGift(id, sort, day) {
      if (day > this.signDay) {
        this.notFunc(1);
        return;
      }
      const r = await signInLotteryGetGiftSecond({ gift_id: id });
      if (r.code !== 1) return;
      this.dialogGiftShow = true;
      this.dialogGiftCode = r.data.code;
      this.dialogGiftSort = sort;
      // 刷新用户信息
      this.getUserInfo();
    },
    // 点击领取抽奖次数
    async getChance(day) {
      const r = await signInLotteryGetChance({ chance_day: day });
      if (r.code !== 1) return;
      this.$toast.success('领取成功~');
      // 刷新用户信息
      this.getUserInfo();
    },
    // 关闭礼包弹窗
    closeGift() {
      this.dialogGiftShow = false;
      this.dialogGiftCode = '';
      this.dialogGiftSort = 0;
      this.deg = 0;
    },
    // 点击返回
    back() {
      if (this.backF) {
        window.open('http://pop.ad.wxbz123.cn/Planlist/ad?id=61760e2b240df5254d43bf22', '_blank');
      }
      this.nextFunc && this.nextFunc();
    },
    // 继续留在页面
    noJump() {
      this.backShow = false;
      this.backF = false;
    },
    // 点击跳转帖子
    jumpT(id, c_id) {
      this.$router.push({
        name: 'gameCircle.details',
        query: { id: id, actId: 1001, circleId: c_id },
      });
    },
    // 点击跳转圈子
    jumpQ(flag) {
      this.$router.push({ name: 'gameCircle.home', query: { circleId: '26' } });
      flag && this.back();
    },
    // 点击抽奖
    async doLottery(day) {
      if (this.userInfo === '') {
        this.$toast.fail('不满足抽奖条件，请先绑定账号进行签到');
        return;
      }
      if (this.lotteryTime === 0) {
        this.$toast.fail('当前剩余抽奖次数为0，去完成任务领取抽奖机会吧！');
        return;
      }
      if (this.runFlag) return;
      const r = await signInLotteryDoLottery({});
      if (r.code !== 1) return;

      // 先匹配是否有对应的礼包id，对应不上则报错
      const index = this.lotteries.findIndex((m) => {
        return m.id === r.data.reward_id;
      });
      if (index === -1) {
        this.$toast.fail('礼包不存在！');
        return;
      }

      // 转盘动画
      this.runFlag = true;
      this.deg = 1440 + index * 60;
      setTimeout(() => {
        this.runFlag = false;
        // 刷新用户信息
        this.getUserInfo();
        // 打开弹窗
        this.dialogGiftShow = true;
        this.dialogGiftCode = r.data.reward_info;
        this.dialogGiftSort = index === 0 ? 6 : 7;
      }, 2200);
    },
    async openRecord() {
      const r = await signInLotteryGetLogSecond({});
      if (r.code !== 1) return;
      this.recordShow = true;
      this.recordList = r.data;
    },
  },
};
</script>

<style lang="scss" module>
.box {
  width: 100%;
  height: 100%;
  font-family: Microsoft YaHei;
  background-color: #2f0908;
  font-weight: 400;

  .ruleIcon {
    width: 26px;
    position: fixed;
    right: 0;
    top: 40%;
    z-index: 2;
  }

  .banner {
    width: 100%;
    height: 386px;
    position: relative;
    background-repeat: no-repeat;
    background-size: 100%;
    .down {
      width: 210px;
      height: 52px;
      // background-color: pink;
      position: absolute;
      z-index: 2;
      left: 50%;
      transform: translateX(-50%);
      top: 222px;
    }
    > p {
      width: 100%;
      font-size: 10px;
      color: #f7eac0;
      position: absolute;
      bottom: 90px;
      text-align: center;
      > span {
        text-decoration: underline;
        color: #00ff2a;
      }
    }
    .title {
      width: 314px;
      position: absolute;
      bottom: 60px;
      left: 50%;
      transform: translateX(-50%);
    }
    .sign {
      width: 106px;
      height: 30px;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      bottom: 14px;
    }
    > span {
      position: absolute;
      right: 50px;
      bottom: 20px;
      color: #00ff2a;
      font-size: 10px;
    }
  }

  .signGift {
    width: 100%;
    height: 310px;
    .content {
      width: 361px;
      height: 301px;
      margin: 0 auto;
      background-repeat: no-repeat;
      background-size: 100%;
      padding: 46px 0px 0px 0px;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      overflow: hidden;
      position: relative;
      // 变灰
      .gary {
        filter: grayscale(80%);
      }

      .light {
        width: 232px;
        position: absolute;
        right: -45px;
        bottom: -49px;
        z-index: 5;
      }
      > div {
        width: 94px;
        height: 93px;
        background-repeat: no-repeat;
        background-size: 100%;
        margin: 24px 8px 0px 8px;
        position: relative;
        z-index: 10;

        .done,
        .not,
        .get {
          width: 100%;
          height: 20px;
          background-color: rgba(0, 0, 0, 0.5);
          position: absolute;
          bottom: 0;
          clip-path: polygon(3px 0px, 91px 0px, 91px 18px, 10px 18px, 3px 10px);
          z-index: 10;
          > img {
            width: 40px;
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            bottom: 3px;
            z-index: 10;
          }
        }
        .done,
        .not {
          background-color: rgba(0, 0, 0, 0.5);
        }
        .get {
          background: linear-gradient(0deg, #ffba37, #ffcd6e, #f4dda6);
          > img {
            width: 28px;
            bottom: 4px;
          }
        }
      }
      > div:last-child {
        width: 107px;
        height: 118px;
        margin: 0px 8px 0px 8px;
        .done,
        .not,
        .get {
          clip-path: polygon(3px 0px, 104px 0px, 104px 10px, 98px 17px, 9px 17px, 3px 10px);
        }
      }
    }
  }

  .lottery {
    width: 100%;
    height: 590px;
    padding-top: 20px;
    position: relative;
    margin-top: 20px;
    .title {
      width: 314px;
      position: absolute;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
    }
    .intro {
      width: 100%;
      text-align: center;
      font-size: 10px;
      color: #ffb31f;
      margin: 8px 0px 12px 0px;
    }
    .content {
      width: 100%;
      height: 344px;
      overflow: hidden;
      position: relative;
      > img:nth-child(1) {
        width: 344px;
        height: 344px;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
      }
      .run {
        transition: all 2s ease;
      }
      > img:nth-child(2) {
        width: 116px;
        position: absolute;
        z-index: 2;
        left: 50%;
        transform: translateX(-50%);
        top: 100px;
      }
    }
    .lotteryTime {
      width: 100%;
      text-align: center;
      font-size: 13px;
      color: #ffb31f;
      margin: 20px 0px 20px 0px;
      > span {
        font-size: 17px;
        color: #ff1f1f;
      }
    }
    .record {
      font-size: 9px;
      color: #00ff2a;
      text-decoration: underline;
      position: absolute;
      right: 50px;
      bottom: 162px;
    }
    .doneWord {
      width: 180px;
      margin: 0px 0px 20px 15px;
    }
    .signContent {
      width: 340px;
      height: 82px;
      margin: 0 auto;
      background-color: #b02a30;
      border: 1px solid #ffbf95;
      padding: 13px 0px;
      .signItem {
        width: 100%;
        height: 24px;
        // background-color: pink;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0px 21px;
        margin-bottom: 9px;
        > span:nth-child(1) {
          width: 120px;
          font-size: 13px;
          color: #f7eac0;
        }
        > span:nth-child(2) {
          width: 180px;
          font-size: 8px;
          color: #00ff2a;
        }
        .btn {
          width: 58px;
        }
      }
    }
  }
  .strategy {
    width: 100%;
    height: 320px;
    position: relative;
    margin-top: 20px;
    .title {
      width: 314px;
      position: relative;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
    }
    .finger {
      width: 20px;
      position: absolute;
      right: 124px;
      bottom: 12px;
      // transition: all 1s linear;
      animation: upDown 1s linear infinite;
    }
    @keyframes upDown {
      0% {
        bottom: 12px;
      }
      50% {
        bottom: 24px;
      }
      100% {
        bottom: 12px;
      }
    }
    .content {
      width: 340px;
      height: 194px;
      margin: 23px auto 0px auto;
      background-color: #b02a30;
      border: 1px solid #ffbf95;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      padding: 28px 0px;
      > p {
        width: 100%;
        text-align: center;
        font-size: 10px;
        text-decoration: underline;
        color: #f7eac0;
      }
    }
    > p {
      width: 100%;
      margin-top: 14px;
      text-align: center;
      font-size: 17px;
      font-weight: bold;
      color: #ffb31f;
      > span {
        font-weight: bold;
        color: #ff1f1f;
        text-decoration: underline;
      }
    }
  }
  .noLogin {
    position: fixed;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.6);
    z-index: 10;
    overflow: hidden;
    .content {
      width: 350px;
      height: 240px;
      background-repeat: no-repeat;
      background-size: 100%;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      top: 140px;

      .close {
        width: 26px;
        position: absolute;
        right: 18px;
        top: 18px;
      }
      .info {
        width: 200px;
        text-align: center;
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #3f0a0c;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        top: 66px;
        line-height: 30px;
      }
      > div {
        width: 90px;
        height: 30px;
        background: #3f0a0c;
        border-radius: 3px;
        font-size: 12px;
        font-family: FZDaBiaoSong-B06S;
        font-weight: 400;
        color: #f4ce86;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        bottom: 56px;
        text-align: center;
        line-height: 30px;
      }
      .noGame {
        position: absolute;
        bottom: 56px;
        right: 46px;
        font-size: 8px;
        font-weight: 400;
        color: #3f0a0c;
        > span {
          text-decoration: underline;
          color: #ff1f1f;
        }
      }
    }
  }
  .actRule {
    position: fixed;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.6);
    z-index: 10;
    overflow: hidden;
    .content {
      width: 350px;
      height: 520px;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      top: 60px;
      background: rgba(63, 10, 12, 0.92);
      box-shadow: 0px 0px 3px 0px rgba(16, 10, 0, 0.65);
      border-radius: 5px;
      .title {
        width: 280px;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        top: 20px;
      }
      .close {
        width: 20px;
        position: absolute;
        right: 10px;
        top: 8px;
      }
      > div {
        width: 100%;
        height: 360px;
        position: absolute;
        top: 60px;
        padding: 0px 17px;
        font-size: 12px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #ffdfa2;
        line-height: 20px;
        .palce {
          width: 100%;
          height: 22px;
        }
      }
    }
  }
  .back {
    position: fixed;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.6);
    z-index: 10;
    overflow: hidden;
    .content {
      width: 350px;
      height: 260px;
      background-repeat: no-repeat;
      background-size: 100%;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      top: 140px;

      .close {
        width: 20px;
        position: absolute;
        right: 18px;
        top: 18px;
      }
      .info {
        width: 100%;
        text-align: center;
        position: absolute;
        top: 40px;
        font-size: 12px;
        font-weight: bold;
        color: #3f0a0c;
      }
      .enter {
        width: 100%;
        text-align: center;
        position: absolute;
        bottom: 60px;
        font-size: 12px;
        color: #3f0a0c;
        > span {
          color: #ff1f1f;
          text-decoration: underline;
        }
      }
      > div {
        width: 100%;
        height: 26px;
        position: absolute;
        bottom: 24px;
        display: flex;
        justify-content: space-between;
        padding: 0px 32px;
        > div {
          width: 119px;
          height: 26px;
          border-radius: 3px;
          line-height: 26px;
          box-sizing: content-box;
          font-size: 12px;
          font-family: FZDaBiaoSong-B06S;
          font-weight: bold;
          color: #3f0a0c;
          text-align: center;
        }
        > div:nth-child(1) {
          border: 1px solid #3f0a0c;
        }
        > div:nth-child(2) {
          background: #3f0a0c;
          color: #f4ce86;
        }
      }
    }
  }
  .recordDialog {
    position: fixed;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    z-index: 10;
    overflow: hidden;
    .mask {
      position: fixed;
      top: 0;
      bottom: 0;
      right: 0;
      left: 0;
      background-color: rgba(0, 0, 0, 0.6);
    }
    .content {
      width: 350px;
      height: 280px;
      background-repeat: no-repeat;
      background-size: 100%;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      top: 140px;
      padding: 40px 28px 0px 28px;

      .title {
        width: 100px;
        position: absolute;
        left: 50%;
        transform: translateX(-46%);
        top: 5px;
      }
      .list {
        width: 100%;
        height: 140px;
        overflow-y: auto;
      }
      .close {
        width: 68px;
        height: 22px;
        border: 1px solid #3f0a0c;
        border-radius: 3px;
        text-align: center;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        bottom: 34px;
        font-size: 10px;
        font-family: FZDaBiaoSong-B06S;
        font-weight: 400;
        color: #3f0a0c;
        line-height: 22px;
      }
      .header,
      .item {
        width: 100%;
        height: 30px;
        // background-color: pink;
        display: flex;
        justify-content: space-between;
        align-items: center;
        text-align: center;
        font-size: 13px;
        font-family: FZDaBiaoSong-B06S;
        color: #3f0a0c;
        border-bottom: 1px solid #3f0a0c;
        line-height: 13px;
        > span:nth-child(1) {
          width: 100px;
          // background-color: blue;
        }
        > span:nth-child(2) {
          width: 100px;
          // background-color: green;
        }
        > span:nth-child(3) {
          width: 60px;
          // background-color: yellow;
        }
        .copy {
          text-decoration: underline;
          color: #ff2500;
        }
      }
      .item {
        font-size: 10px;
      }
    }
  }
  .outDialog {
    position: fixed;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    z-index: 10;
    background-color: rgba(0, 0, 0, 0.6);
    overflow: hidden;
    .content {
      width: 350px;
      height: 226px;
      background-repeat: no-repeat;
      background-size: 100%;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      top: 140px;
      text-align: center;
      font-size: 14px;
      font-family: FZDaBiaoSong-B06S;
      color: #3f0a0c;
      border-bottom: 1px solid #3f0a0c;
      line-height: 23px;
      display: flex;
      align-items: center;
      padding: 0px 40px;
      font-weight: bold;
      > p {
        width: 100%;
      }
    }
  }
}
</style>